import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { useEffect } from 'react';

import {
  TRACKING_EVENT_NAMES,
  ACTION_SUBJECT_IDS
} from '../../utils/constants';
import { linkStyle } from './show-all-link.styles';

interface ShowAllLinkProps {
  addPaymentDetailsURL: string;
  analyticsAttributes: object;
  totalEntitlementsCount: number;
}

const ShowAllLink = ({
  addPaymentDetailsURL,
  analyticsAttributes,
  totalEntitlementsCount
}: ShowAllLinkProps) => {
  const { createAnalyticsEvent } = useAnalyticsEvents();

  useEffect(() => {
    createAnalyticsEvent({
      eventName: TRACKING_EVENT_NAMES.showAllLinkDisplayed,
      action: 'displayed',
      actionSubject: 'showAllLink',
      actionSubjectId: ACTION_SUBJECT_IDS.wacCartShowAllLinkDisplayed,
      attributes: analyticsAttributes
    }).fire();
  }, []);

  return (
    <a
      css={linkStyle}
      href={addPaymentDetailsURL}
      target="_blank"
      rel="noreferrer"
      onClick={() => {
        createAnalyticsEvent({
          eventName: TRACKING_EVENT_NAMES.showAllLinkClicked,
          action: 'clicked',
          actionSubject: 'showAllLink',
          actionSubjectId: ACTION_SUBJECT_IDS.wacCartShowAllLinkClicked,
          attributes: analyticsAttributes
        }).fire();
      }}
    >
      Show all {totalEntitlementsCount} products
    </a>
  );
};

export { ShowAllLink };
